import React from 'react';
import styled from 'styled-components';
import {Dialog, ClickAwayListener}from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
// import ReactPlayer from 'react-player';
// import Tutorial from '../assets/tutorials/OfficeHours_Students.mp4';

const Tutorial = "https://www.youtube.com/embed/PWjQVmhKipM"


const VideoPlayer = (props) => {
    const {open, close} = props

    return(
        <StyledDialog open={open} maxWidth="lg" fullWidth={true}>
            <ClickAwayListener onClickAway={close}>
                <div>
                    <StyledCloseBtn onClick={close} />
                    {/* <ReactPlayer style={{background:"black"}} width="100%" height="100%" url={Tutorial} playing={true} controls={true} /> */}
                    <iframe width="880" height="480" src={Tutorial} allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
                </div>
            </ClickAwayListener>
        </StyledDialog>
    )
}

export default VideoPlayer;

const StyledDialog = styled(Dialog)`
    && {
        display: flex;
        align-items: center;
        justify-content: center;
    }
`;

const StyledCloseBtn = styled(CloseIcon)`
    cursor: pointer;
    color: white;
    position: absolute;
    top: 10px;
    right: 10px;
    z-index: 10;
`;